import {
  ListItemText,
  ListItemIcon,
  Menu,
  MenuItem,
  PopoverVirtualElement,
} from '@mui/material';
import { IconExternalLink } from '@tabler/icons-react';
import _ from 'lodash';
import { SyntheticEvent, useState } from 'react';
import SegmentIconButton from 'ui-component/Segment/SegmentIconButton';
import { getTrackingUrl } from 'utils/shipmentTracking';

const InlineTrackingLink = ({
  trackingNumber,
}: {
  trackingNumber: string | null | undefined;
}) => {
  const [anchorEl, setAnchorEl] = useState<
    Element | PopoverVirtualElement | null
  >(null);

  const handleClick = (event: SyntheticEvent) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!trackingNumber) return null;

  const urls = _.chain(trackingNumber)
    .trim()
    .split(',')
    .map(getTrackingUrl)
    .compact()
    .value();

  if (urls.length === 0) return null;

  if (urls.length === 1) {
    return (
      <SegmentIconButton
        onClick={() => {
          window.open(urls[0], '_blank');
        }}
        size="small"
      >
        <IconExternalLink width={20} height={20} />
      </SegmentIconButton>
    );
  }

  return (
    <>
      <Menu
        id="menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        variant="selectedMenu"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {urls.map((url) => (
          <MenuItem
            key={url}
            onClick={() => {
              window.open(url, '_blank');
              handleClose();
            }}
          >
            <ListItemIcon>
              <IconExternalLink />
            </ListItemIcon>
            <ListItemText>{url}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
      <SegmentIconButton
        onMouseDown={(event) => event.stopPropagation()}
        onTouchStart={(event) => event.stopPropagation()}
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          handleClick(event);
        }}
        size="small"
      >
        <IconExternalLink width={20} height={20} />
      </SegmentIconButton>
    </>
  );
};

export default InlineTrackingLink;
